module.exports = __webpack_public_path__ + "static/img/zzc_8.e0fdaff.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/Zuzuche_Pro/zzc_8.png
// module id = Zu0B
// module chunks = 19